import { IBase } from "../shared/IBase";
import { ELanguage } from "../../enums/user/ELanguage";

export interface IEmailList extends IBase {
  category: EEmailCategory;
  language: ELanguage;
  name: string;
  recipients: IEmailRecipient[];
}

export enum EEmailCategory {
  MEDICAL = "MEDICAL",
  DENTAL = "DENTAL",
  HR = "HR",
  SOFTWARE = "SOFTWARE",
  HOTEL = "HOTEL",
}

export interface IEmailRecipient {
  email: string;
  companyName?: string;
  fullName: string;
  lastError?: string;
  region?: string;
  status: string;
  websiteUrl: string;
}

export interface IEmailStats {
  category: EEmailCategory;
  language: ELanguage;
  name: string;
  pending: number;
  sent: number;
  total: number;
  failed: number;
  successRate: string;
}

export interface ICreateEmailList {
  name: string;
  category: EEmailCategory;
  language: ELanguage;
  file: File;
}
